export const getLessonByKey = (state, lessonKey) =>
  state.moduleActivity
    .get('lessons')
    .find((l) => l.get('key') === lessonKey)
    .toJS();
